<script>
import appConfig from '@src/app.config.json'
import Axios from 'axios'
import Layout from '@layouts/main.vue'

export default {
  page: {
    title: 'Contact',
    meta: [{ name: 'description', content: 'The Contact page.' }],
  },
  components: { Layout },
  data() {
    return {
      status: null,
      isDisabled: false,
      isLoading: false,
      contact: {
        title: '',
        content: '',
        atribut: {
          full_name: {
            content: '',
          },
          email: {
            content: '',
          },
        },
      },
    }
  },
  methods: {
    submit: function(evt) {
      evt.preventDefault()
      var dataToPush = JSON.stringify([this.contact])
      /** token required for getting data from backend  */
      const getOptions = {
        headers: {
          Authorization: appConfig.default_token,
          'Access-Control-Allow-Origin': '*',
        },
      }
      if (this.isDisabled === false) {
        this.isLoading = true
        Axios.post(
          `${appConfig.endpoint}/klaster-by-member-record-add/contact`,
          dataToPush,
          getOptions
        ).then(
          (response) => {
            if (response.status === 200) {
              this.status = 200
              this.isDisabled = true
              this.isLoading = false
              setTimeout(() => {
                this.status = null
                this.isDisabled = false
              }, 30 * 1000)
            }
          },
          (error) => {
            this.status = error
          }
        )
      }
    },
  },
}
</script>

<template>
  <Layout>
    <b-container class="my-5">
      <b-form class="row" @submit="submit">
        <b-col cols="12" class="my-4">
          <h1 class="text-primary" :style="{ fontWeight: 700 }">{{
            $t('contact')
          }}</h1>
        </b-col>
        <b-col cols="12">
          <b-alert v-if="status === 200" variant="success" show dismissible>
            {{ $t('Your message has been sent.') }}
          </b-alert>
        </b-col>
        <b-col cols="lg-6">
          <b-form-group>
            <b-form-input
              v-model="contact.atribut.full_name.content"
              type="text"
              required
              :placeholder="$t('Your full name')"
            ></b-form-input>
          </b-form-group>
        </b-col>
        <b-col cols="lg-6">
          <b-form-group>
            <b-form-input
              v-model="contact.atribut.email.content"
              type="email"
              required
              :placeholder="$t('Your email address')"
            ></b-form-input>
          </b-form-group>
        </b-col>
        <b-col cols="12" class="my-4">
          <b-form-group>
            <b-form-input
              v-model="contact.title"
              type="text"
              required
              :placeholder="$t('Subject line')"
            ></b-form-input>
          </b-form-group>
        </b-col>
        <b-col cols="12">
          <b-form-textarea
            id="textarea-rows"
            v-model="contact.content"
            :placeholder="$t('Message')"
            rows="0"
          ></b-form-textarea>
        </b-col>
        <b-col class="my-5">
          <b-button
            :variant="
              status === null
                ? 'primary'
                : status === 200
                ? 'success'
                : 'danger'
            "
            type="submit"
            class="px-5 py-2"
            :class="[isDisabled ? 'disabled' : '']"
            >{{
              status === 200
                ? 'Submitted!'
                : isLoading
                ? 'Submitting'
                : 'Submit'
            }}</b-button
          >
        </b-col>
      </b-form>
      <b-row class="my-5">
        <b-col cols="12">
          <b-card :style="{ borderRadius: 0 }" class="p-3 p-lg-5">
            <b-row>
              <b-col cols="lg-6">
                <h2 class="text-primary">{{ $t('Location') }}</h2>
                <span class="mt-3 d-block"
                  >Puri Imperium Office Plaza Blok UG No. 11-12, Jl. Kuningan
                  Madya Kav 5-6, Kuningan, RW.6, Guntur, Kota Jakarta Selatan,
                  Daerah Khusus Ibukota Jakarta 12980</span
                >
              </b-col>
              <b-col cols="lg-6 mt-3 mt-lg-0">
                <h2 class="text-primary">{{ $t('Email') }}</h2>
                <div class="my-3">
                  <img
                    src="@assets/icons/Icon_Email.png"
                    alt="icon_email"
                    width="32"
                    class="mr-3"
                  />
                  <a href="mailto:info@lexikan.id" :style="{ color: 'gray' }"
                    >info@lexikan.id</a
                  >
                </div>
                <h2 class="text-primary">{{ $t('Phone') }}</h2>
                <div class="my-3">
                  <img
                    src="@assets/icons/Icon_Phone.png"
                    alt="icon_email"
                    width="32"
                    class="mr-3"
                  />
                  <a href="tel:62000000" :style="{ color: 'gray' }"
                    >+62 822 9966 7850</a
                  >
                </div>
              </b-col>
            </b-row>
          </b-card>
        </b-col>
      </b-row>
    </b-container>
  </Layout>
</template>
